import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/transport',
    name: 'Transport',
    component: () => import('../views/transport/Transport.vue')
  },
  {
    path: '/transport/at',
    name: 'AT',
    component: () => import('../views/transport/AT.vue')
  },
  {
    path: '/transport/get-at-apps',
    name: 'Get AT Apps',
    component: () => import('../views/transport/GetATApps.vue')
  },
  {
    path: '/transport/live-departures',
    name: 'Live Departures',
    component: () => import('../views/transport/LiveDepartures.vue')
  },
  {
    path: '/transport/taxis-united',
    name: 'Taxis United',
    component: () => import('../views/transport/TaxisUnited.vue')
  },
  {
    path: '/transport/traffic-camera',
    name: 'Traffic Camera',
    component: () => import('../views/transport/TrafficCamera.vue')
  },
  {
    path: '/transport/estimate-travel-times',
    name: 'Estimate Travel Times',
    component: () => import('../views/transport/EstimateTravelTimes.vue')
  },
  {
    path: '/transport/my-ap-hop',
    name: 'My AT HOP',
    component: () => import('../views/transport/MyATHOP.vue')
  },
  {
    path: '/whats-on',
    name: 'Whats On',
    component: () => import('../views/WhatsOn.vue')
  },
  {
    path: '/whats-on/publications',
    name: 'Local Publication',
    component: () => import('../views/whats-on/LocalPublication.vue')
  },
  {
    path: '/region-vouchers',
    name: 'Region Vouchers',
    component: () => import('../views/voucher/GiftVouchers.vue')
  },
  {
    path: '/campaigns',
    name: 'Gift Voucher Regions',
    component: () => import('../views/voucher/VoucherRegions.vue')
  },
  {
    path: '/store-directory',
    name: 'Store Directory',
    component: () => import('../views/StoreDirectory.vue')
  },
  {
    path: '/jobs',
    name: 'Jobs',
    component: () => import('../views/Jobs.vue')
  },
  {
    path: '/whats-on/auckland-live',
    name: 'Auckland Live Landing',
    component: () => import('../views/whats-on/AucklandLiveLandingPage.vue')
  },
  {
    path: '/whats-on/auckland-unlimited',
    name: 'Auckland Unlimited',
    component: () => import('../views/whats-on/AucklandLive.vue')
  },
  {
    path: '/whats-on/venues-events',
    name: 'Venues and Events',
    component: () => import('../views/whats-on/VenuesAndEvents.vue')
  },
  {
    path: '/whats-on/our-community',
    name: 'Our Community',
    component: () => import('../views/whats-on/OurCommunity.vue')
  },
  {
    path: '/whats-on/local-attractions',
    name: 'Explore',
    component: () => import('../views/whats-on/LocalAttractions.vue')
  },
  {
    path: '/whats-on/local-events',
    name: 'Local Events',
    component: () => import('../views/whats-on/LocalEvents.vue')
  },
  {
    path: '/campaigns/request',
    name: 'Request Gift Vouchers',
    component: () => import('../views/voucher/RequestVoucher.vue')
  },
  {
    path: '/campaigns/competitions',
    name: 'Campaigns Competition',
    component: () => import('../views/voucher/MilfordCompetition.vue')
  },
  {
    path: '/road-maintenance/:suburb',
    name: 'Road Maintenance',
    component: () => import('../views/transport/RoadMaintenance.vue')
  },
  {
    path: '/emergency-numbers',
    name: 'Emergency Numbers',
    component: () => import('../views/single-pages/EmergencyNumbers')
  },
  {
    path: '/privacy',
    name: 'Privacy Policy',
    component: () => import('../views/single-pages/Privacy')
  },
  {
    path: '/weather',
    name: 'Weather Page',
    component: () => import('../views/WeatherPage.vue')
  },
  {
    path: '/jobs',
    name: 'Jobs',
    component: () => import('../views/Jobs.vue')
  },
  {
    path: '/webcams',
    name: 'Web Cams',
    component: () => import('../views/WeatherSurfCams.vue')
  },
  {
    path: '/bid-areas',
    name: 'Bid Areas',
    component: () => import('../views/BidAreas.vue')
  },
  {
    path: '/tangata-whenua',
    name: 'Tangata Whenua',
    component: () => import('../views/TangataWhenua.vue')
  },
  {
    path: '/facebook-links',
    name: 'Facebook Links',
    component: () => import('../views/whats-on/FacebookLinks.vue')
  },
  {
    path: '/have-your-say',
    name: 'Have Your Say',
    component: () => import('../views/HaveYourSay.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.afterEach((to) => {
  if (window.dataLayer) {
    window.dataLayer.push({
      event: 'manual_page_view',
      pageTitle: to.name,
      pagePath: to.fullPath
    })
  }
  Vue.nextTick(() => {
    document.title = to.name || 'Otahuhu Mini Site';
  })
})

export default router
